import twLocale from 'element-ui/lib/locale/lang/zh-TW'

const lang = {
  ...twLocale,
  layoutHeader: {
    login: '登錄',
    register: '註冊',
    linkHome: '首頁',
    linkEmploy: '就業',
    linkBusiness: '創業',
    linkBothMeetRoom: '兩岸人才會客廳',
    linkTalentPool: '人才庫',
    linkPolicyInfo: '政策資訊',
    linkContactUs: '聯系我們'
  },
  login: {
    loginText: '歡迎登錄！',
    title: '廈門市思明區台灣人才服務中心',
    loginText1: '個人登錄',
    loginText2: '企業登錄',
    placeholder1: '請輸入賬號',
    placeholder2: '請輸入密碼',
    placeholder3: '請輸入驗證碼',
    placeholder4: '請輸入密碼',
    placeholder5: '請再次輸入密碼',
    loginButton: '登錄',
    registerButton: '註冊',
    noAccount: '沒有賬號？',
    register: '立即註冊'
  },
  register: {
    title: '廈門市思明區台灣人才服務中心',
    registerText1: '個人註冊',
    registerText2: '企業註冊',
    placeholder1: '請輸入賬號',
    placeholder2: '請輸入密碼',
    placeholder3: '請再次輸入密碼',
    placeholder4: '請輸入圖形驗證碼',
    placeholder5: '請輸入企業名稱',
    placeholder6: '請輸入企業郵箱',
    placeholder7: '請輸入統一社會信用代碼',
    placeholder8: '請上傳營業執照',
    hasAccount: '已有賬號？',
    returnLogin: '返回登錄'
  },
  layoutFooter: {
    link: '友情鏈接',
    link1: '廈門市人力資源和社會保障局',
    link2: '台灣青年就業廣場',
    link3: 'i人才',
    time: '工作時間',
    contact: '聯繫我們',
    tel: '市話: 0592-5808611',
    addressTitle: '通訊位址',
    address: '地址: 廈門市思明區龍山南路84號工業設計中心212室',
    title: '廈門市思明區台灣人才服務中心',
    unit: '主管單位：廈門市思明區人民政府台灣事務辦公室',
    bottomText: '工業和信息化部備案號：',
    internetContentProvider: '閩ICP備2021012396號-1'
  },
  home: {
    introduceTitle: '廈門市思明區台灣人才服務中心簡介',
    introduce:
      '廈門市思明區台灣人才服務中心是思明區人民政府與中國海峽人才市場共同組建，主要為廈門市企事業單位與台灣人才提供“一條龍、一站式”的專業化人才綜合服務平台，中心 秉持“人才服務·服務人才”的理念，致力於發揮思明區對台服務工作的示範、帶動及輻射 作用，更好服務廣大台灣人才和用人單位，為台灣人才在廈門思明區的生活、就業、創業等 方面提供堅實的支撐，打造兩岸人才交流合作與發展的事業圈和朋友圈，共創兩岸人才融合 發展的美好未來。服務內容：（一）提供“一條龍、一站式”的人才服務窗口中心為台灣各 類人才來廈創業就業實習提供政策諮詢、對接和綜合輔導服務。 （二）提供線上“直通車” 人才供需對接系統中心搭建全國首個針對台灣人才服務網站，充分利用新媒體矩陣全面立體 快捷的傳播服務優勢，為思明區用人單位和台灣人才之間搭建一個高效對接的互動平台，為 企事業單位和人才提供線上求職、招聘、人事代理、人才培訓、政策諮詢及招聘會等實用服 務。中心同步打造“廈門市思明區台灣人才服務中心”微信服務號為其提供就業資源對接、 就業輔導等“直通車”服務。 （三）提供專業化定制人才服務中心針對企事業單位和台灣人 才需求提供人才推薦、人才培訓、職業生涯規劃、...',
    infoTitle: '資訊中心',
    newsTitle: '信息中心'
  }
}
export default lang
